import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess6020ListeStatus: 'idle',
    startProcess6020ListeError: undefined as any,
    loadUserParamsProcess6020ListeStatus: 'idle',
    loadUserParamsProcess6020ListeError: undefined as any,

    process6020ListeList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess6020Liste = createAsyncThunk('process6020ListeSlice/startProcess6020Liste', async ({ process6020Liste }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess6020Liste/`,
        prepareData(process6020Liste),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess6020ListeStatus } = getState().process6020ListeSlice
        return startProcess6020ListeStatus !== 'pending'
    }
})

export const loadUserParamsProcess6020Liste = createAsyncThunk('process6020ListeSlice/loadUserParamsProcess6020Liste', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess6020Liste/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess6020ListeStatus } = getState().process6020ListeSlice
        return loadUserParamsProcess6020ListeStatus !== 'pending'
    }
})

const Process6020ListeSlice = createSlice({
    name: 'process6020ListeSlice',
    initialState,
    reducers: {
        resetstartProcess6020Liste: (state) => {
            state.job = undefined
            state.startProcess6020ListeError = undefined
        },
        resetstartProcess6020ListeError: (state) => {
            state.startProcess6020ListeError = undefined
        },
        resetloadUserParamsProcess6020Liste: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess6020ListeError = undefined
        },
        resetloadUserParamsProcess6020ListeError: (state) => {
            state.loadUserParamsProcess6020ListeError = undefined
        },
        removeFromProcess6020ListeListById: (state, action) => {
            state.process6020ListeList = state.process6020ListeList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess6020ListeListByIds: (state, action) => {
            state.process6020ListeList = state.process6020ListeList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process6020ListeList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess6020ListeStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process6020ListeList = []
            state.startProcess6020ListeStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess6020Liste.pending, (state) => {
            state.startProcess6020ListeStatus = 'pending'
            state.startProcess6020ListeError = undefined
        })
        builder.addCase(startProcess6020Liste.fulfilled, (state, action) => {
            state.startProcess6020ListeStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess6020Liste.rejected, (state, action) => {
            state.startProcess6020ListeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess6020ListeError = action.error.message
            } else {
                state.startProcess6020ListeError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess6020Liste.pending, (state) => {
            state.loadUserParamsProcess6020ListeStatus = 'pending'
            state.loadUserParamsProcess6020ListeError = undefined
        })
        builder.addCase(loadUserParamsProcess6020Liste.fulfilled, (state, action) => {
            state.loadUserParamsProcess6020ListeStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess6020Liste.rejected, (state, action) => {
            state.loadUserParamsProcess6020ListeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess6020ListeError = action.error.message
            } else {
                state.loadUserParamsProcess6020ListeError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess6020Liste,
    resetstartProcess6020ListeError,
    resetloadUserParamsProcess6020Liste,
    resetloadUserParamsProcess6020ListeError,
    removeFromProcess6020ListeListById,
    removeFromProcess6020ListeListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process6020ListeSlice.actions
export default Process6020ListeSlice.reducer
